import { IOdataField } from '../Field/IOdataField';

export class OdataSelect {
  private field: IOdataField;

  constructor(field: IOdataField) {
    this.field = field;
  }

  toSelectString() {
    return this.field.toFieldString();
  }
}
